import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, async, lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public userObservable: BehaviorSubject<any> = new BehaviorSubject({});
  public $refreshToken = new Subject<boolean>();
  public $refreshTokenReceived = new Subject<boolean>();

  constructor(private http: HttpClient) {
    this.$refreshToken.subscribe((res: any) => {
      this.recuperarRefreshToken();
    });
  }

  async recuperarRefreshToken() {
    const body = {
      usuario: {
        email: localStorage.getItem('email'),
        nome: localStorage.getItem('nome'),
      },
      accessToke: '',
      refreshToken: localStorage.getItem('refreshToken'),
    };
    return lastValueFrom(
      this.http.post(`${environment.apiUrl}/auth/login/backoffice`, body)
    );
  }

  async login(usuario: string, senha: string) {
    return await lastValueFrom(
      this.http.post(`${environment.apiUrl}/auth/login/backoffice`, {
        username: usuario,
        password: senha,
        backoffice: true,
      })
    );
  }

  get perfil() {
    return localStorage.getItem('perfil') || sessionStorage.getItem('perfil');
  }

  get usuarioId() {
    return localStorage.getItem('id') || sessionStorage.getItem('id');
  }

  get usuarioPerfil() {
    return localStorage.getItem('perfil') || sessionStorage.getItem('perfil');
  }
  get restauranteId() {
    return localStorage.getItem('restauranteId') || sessionStorage.getItem('restauranteId');
  }

  get planoPro(){
    return localStorage.getItem('planoPro') || sessionStorage.getItem('planoPro');
  }

  get getPlanoPreSelecionado(){
    return localStorage.getItem('planoPreSelecionado') || sessionStorage.getItem('planoPreSelecionado');
  }

  recuperarToken() {
    return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
  }

  async usuarioLogado() {
    return !!(localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken'));
  }

  async usuarioSenhaProvisoria(){
    return !!(localStorage.getItem('senhaProvisoria') || sessionStorage.getItem('senhaProvisoria'));
  }

  async limparAutorizacao(): Promise<void> {
    localStorage.clear();
    sessionStorage.clear();
    this.userObservable.next({});
    Sentry.setUser(null);
  }
}
